/**
 * Avalara © 2019
 * file: engines/opus_ui/src/containers/Statusontainer.jsx
 */

import React from 'react';
import EnvironmentContainer from '../statusItems/EnvironmentContainer';
import EnginesContainer from '../statusItems/EnginesContainer';
import './StatusContainer.css';

export default function StatusContainer() {
  return (
    <div className="status">
      <EnginesContainer />
      <EnvironmentContainer env="prod" />
      <EnvironmentContainer env="sandbox" />
      <EnvironmentContainer env="fqa" />
      <EnvironmentContainer env="cqa" />
    </div>
  );
}
